import { useEffect, useRef } from "react";
import Cookies from 'js-cookie';
import { useSubscription } from '../../shared/hooks/useSubscription';

const AdSenseAd = ({ adSlot, className = "", style = {} }) => {
  const adRef = useRef(null);
  const firebaseUserId = Cookies.get("firebaseuid");
  
  const { subscriptionInfo, loading } = useSubscription(firebaseUserId);

  useEffect(() => {
    if (loading) return;
    if (subscriptionInfo) return;
    if (!adRef.current) return;

    const timeout = setTimeout(() => {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error("AdSense error:", e);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [loading, subscriptionInfo]);

  if (loading) return null;
  if (subscriptionInfo) return null;  

  return (
    <>
      <div style={{ width: "100%", minHeight: 250, textAlign: "center" }}>
        <ins
          ref={adRef}
          className={`adsbygoogle ${className}`}
          style={{ display: "block", ...style }}
          data-ad-client="ca-pub-8759251703965355"
          data-ad-slot={adSlot}
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </>
  );
};

export default AdSenseAd;
